module.exports = __webpack_public_path__ + "img/twoGreen.c33d4490.jpg";